<div class="profile-section-content" #scrollContainer>
    <div class="box-border">
        <div class="box-pedding">

            <form name="frmdelmessages" class="message-block-inbox" *ngIf="MsgResponce !== undefined">
                <div class="msg_list_container">

                    <div class="gray-title-head" *ngIf="!send">
                        <div class="heading-top">
                            <strong>Sender</strong>
                            <strong>Subject</strong>
                        </div>
                    </div>

                    <div class="dsp_vertical_scrollbar" [ngClass]="{ 'send': send }"
                        *ngFor="let msg of MsgResponce; let i = index">
                        <ul class="no-list email-page dspdp-bg-info" [ngClass]="{ 'draft': draft }"
                            [ngClass]="{ 'draft': send }">
                            <li class="wpee-received-checkbox" *ngIf="!this.del">
                                <mat-checkbox class="delete-message-id"
                                    (change)="onCheckboxChange( inbox? msg.conversationId: (draft ? msg._id : (del?msg.conversationId:msg.messageId )) , $event.checked)"></mat-checkbox>
                            </li>
                            <li class="wpee-received-details">
                                <a class="dsp-email-photo" *ngIf="!draft"
                                    [routerLink]="['/member-profile',draft ? msg.targetUser?.username : (send ? msg.userName : msg.senderName),'Profile']">
                                    <img decoding="async"
                                        src="{{ inbox ? msg.senderThumbPic: (send ? msg.profilePic : msg.ThumbPic) }}"
                                        style="width:45px; height:45px;" class="img2" alt="{{userName}}">
                                </a>
                                <span class="name">
                                    <a class="names"
                                        [routerLink]="['/member-profile',draft ? msg.targetUser?.username : (send ? msg.userName : msg.senderName),'Profile']">{{
                                        draft ? msg.targetUser?.username : (send ? msg.userName : msg.senderName) }}</a>
                                    <br>
                                    <p class="msg_data" *ngIf="!send">
                                        {{ draft ? (msg.updatedAt | date: 'MMMM dd, yyyy h:mm a') : msg.date | date:
                                        'MMMM dd, yyyy h:mm a' }}
                                    </p>

                                    <a class="send_sub" *ngIf="send">
                                        Sent - Subject
                                        <span [class.single-line]="toggledIndex !== i"
                                            [class.full-text]="toggledIndex === i">
                                            {{ msg.message }}
                                        </span>
                                        <span class="trun" [class.closed]="toggledIndex !== i"
                                            [class.opened]="toggledIndex === i" *ngIf="msg.message.length > 100"
                                            (click)="toggleText(i)">
                                            {{ toggledIndex === i ? '...hide' : '...more' }}
                                        </span>
                                    </a>
                                    </span>

                            </li>
                            <li style="width:30%;" class="my_msg {{del? 'delete':''}}"
                                (click)="inbox_inside(msg.conversationId)">
                                <a *ngIf="!send" class="draft_msg">
                                    {{ draft ? msg.subject : msg.subject }}
                                </a>
                            </li>
                            <li *ngIf="draft" class="pencile">
                                <span class="pencile_edit draft_pencile"
                                    (click)="editMsg(msg._id,msg.targetUser._id,msg.body,msg.subject,msg.conversation,msg.targetUser.username)">
                                    <fa-icon [icon]='this.pencile'></fa-icon>
                                    <a>Edit</a>
                                </span>
                            </li>
                            <li *ngIf="send">
                                <span class="pencile_edit msgBox"><fa-icon
                                        [icon]='msg.isReadByRecipient? MessageOpen : Message'></fa-icon></span>
                            </li>
                        </ul>
                    </div>
                    <div class="dsp_vertical_scrollbar shine" *ngIf="this.shimmer">
                    </div>
                    <div class="dsp_vertical_scrollbar shine" *ngIf="this.shimmer">
                    </div>
                    <div style="float:left; width:100%;">
                    </div>
                </div>
                <div class="btn-delete" *ngIf="!this.del">
                    <button class="delete_btn" type="button" (click)="deleteMsg()"
                        [disabled]="selectedMsg?.length === 0"> {{isload?"Please Wait...": "Delete Selected"
                        }}<mat-spinner *ngIf="isload" class="custom-spinner"></mat-spinner></button>
                </div>
            </form>

            <div *ngIf="MsgResponce === undefined">
                <p class="empty">Empty</p>
            </div>
        </div>
    </div>
</div>